import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { ParticipationRateMaintenanceProvider } from "presentation/store/ParticipationRate/ParticipationRateMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { ParticipationRateMaintenance } from "presentation/view/section/ParticipationRate/ParticipationRateMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const ParticipationRateMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.PARTICIPATION_RATE_MAINTENANCE}>
        <MessageBarWrapper>
            <ParticipationRateMaintenanceProvider>
                <GridStyles />
                <ParticipationRateMaintenance />
            </ParticipationRateMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default ParticipationRateMaintenanceCont;